import { pauseSmoother, resumeSmoother } from "./gsap/scrollSmootherManager";

jQuery(document).ready(function ($) {

    let currentScreenSize = document.documentElement.clientWidth;
    $(window).on("resize", function () {
        currentScreenSize = document.documentElement.clientWidth;

        setArrowHandling();
        resetNav();
        setSubmenuPosition();
    })

    $('.main-nav li ul.sub-menu').each(function (i) {
        const $submenu = $(this);
        const $link = $submenu.siblings('a');

        const submenuId = `submenu-${i + 1}`;
        $submenu.attr('id', submenuId).attr('hidden', true);

        $link.addClass('hasChildren').after(
            `<button class="arrow" type="button"
                    aria-label="Open sub-menu"
                    aria-expanded="false"
                    aria-controls="${submenuId}">
                <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none" aria-hidden="true" focusable="false">
                    <path d="M6 4.99992L1.757 9.24292L0.343 7.82792L3.172 4.99992L0.343 2.17192L1.757 0.75692L6 4.99992Z" fill="#0861CE"/>
                </svg>
            </button>`
        );
    });

    $(document).on('click', '.arrow', function (e) {
        const $arrow = $(this);
        const submenuId = $arrow.attr('aria-controls');
        const $submenu = $('#' + submenuId);

        const isOpen = $arrow.attr('aria-expanded') === 'true';

        $arrow.attr('aria-expanded', String(!isOpen));
        $submenu.prop('hidden', isOpen);

        $arrow.toggleClass('arrowOpen', !isOpen);
        $submenu.toggleClass('submenuOpen', !isOpen);

        e.preventDefault();
    });

    // Menu arrow icons
    // $('.main-nav li ul').siblings('a').addClass('hasChildren').after('<button class="arrow" aria-label="Open sub-menu" aria-expanded="false" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none"><path d="M6 4.99992L1.757 9.24292L0.343 7.82792L3.172 4.99992L0.343 2.17192L1.757 0.75692L6 4.99992Z" fill="#0861CE"/></svg></button>');

    // function setArrowHandling() {
    //     $('.arrow').off('click');

    //     if (currentScreenSize < 1025) {
    //         $('.arrow').on("click", function (e) {
    //             let submenuOpen = $(this).siblings('.sub-menu').hasClass('submenuOpen');
    //             if (!submenuOpen) {
    //                 $(this).siblings('.sub-menu').addClass('submenuOpen');
    //                 $('body').addClass('menuOpen');
    //                 $(this).addClass('arrowOpen');
    //                 $(this).attr('aria-expanded', 'true');
    //             } else {
    //                 $(this).siblings('.sub-menu').removeClass('submenuOpen');
    //                 $('body').removeClass('menuOpen');
    //                 $(this).removeClass('arrowOpen');
    //                 $(this).attr('aria-expanded', 'false');
    //             }
    //             $('.arrow').each(function (el) {
    //                 let itemWidth = $(this).siblings('.hasChildren').innerWidth();
    //                 $(this).css('left', `calc(90% - ${itemWidth}px)`);
    //             })
    //             e.preventDefault();
    //         });
    //     } else {
    //         $('.main-nav__links').show();

    //         $('.main-nav__links__items > .menu-item > .arrow').each(function (el) {
    //             let itemInnerWidth = $(this).siblings('.hasChildren').innerWidth();
    //             let itemOuterWidth = $(this).parent('li').outerWidth();
    //             let calculatedLeftPadding = Math.abs((itemOuterWidth - itemInnerWidth) / 2);
    //             // $(this).css('left', `calc(${itemInnerWidth}px + ${calculatedLeftPadding}px + 8px)`);
    //             $(this).css('right', '-0.8rem');
    //             $(this).css('left', 'unset');
    //         })

    //         $('.arrow').on("keydown", function (event) {
    //             if (event.key === 'Enter' || event.keyCode === 13 || event.key === 'Space') {
    //                 let $arrowOpen = $(this).hasClass('arrowOpen');
    //                 let $submenu = $(this).siblings('.sub-menu');
    //                 let $submenuOpen = $submenu.hasClass('submenuOpen')

    //                 if (!$arrowOpen) {
    //                     $(this).addClass('arrowOpen');
    //                     $(this).attr('aria-expanded', 'true');
    //                 } else {
    //                     $(this).removeClass('arrowOpen');
    //                     $(this).attr('aria-expanded', 'false');
    //                 }

    //                 if (!$submenuOpen) {
    //                     $submenu.addClass('submenuOpen');
    //                 } else {
    //                     $submenu.removeClass('submenuOpen');
    //                 }
    //             }
    //         });
    //     }
    // }
    // setArrowHandling();

    function resetNav() {
        if (currentScreenSize < 1025) {
            $('.main-nav .sub-menu').slideUp('fast');
        }
    }
    resetNav();

    $('.menuToggle').on('click', function (e) {
        e.preventDefault();
        const $hamburgerMenu = $(this);
        const $menu = $('#main-nav-links');
        const isOpen = $hamburgerMenu.attr('aria-expanded') === 'true';

        $hamburgerMenu.attr('aria-expanded', String(!isOpen));
        $hamburgerMenu.toggleClass('close', !isOpen);
        $menu.slideToggle('fast');
        $('body').toggleClass('menuOpen', !isOpen);

        $('.arrow').each(function () {
            const itemWidth = $(this).siblings('.hasChildren').innerWidth();
            $(this).css('left', `calc(90% - ${itemWidth}px)`);
        });
    });

    // Mobile menu toggle
    // $('.menuToggle').on('click', function (e) {
    //     e.preventDefault();
    //     $('body').toggleClass('menuOpen');
    //     $('.main-nav__links').slideToggle('fast');
    //     $(this).toggleClass('close');
    //     $('.arrow').each(function (el) {
    //         let itemWidth = $(this).siblings('.hasChildren').innerWidth();
    //         $(this).css('left', `calc(90% - ${itemWidth}px)`);
    //     })
    // });

    // Reveal/hide navigation on scroll up/down
    // let body = $('body');
    // let lastScroll = 0;
    // window.addEventListener("scroll", () => {
    //     const currentScroll = window.pageYOffset;
    //     if (currentScroll <= 0) {
    //         body.removeClass('scrollUp');
    //     }

    //     if (!body.hasClass('menuOpen')) {
    //         if ((currentScroll > lastScroll) && !body.hasClass('scrollDown') && currentScroll > 130) {
    //             // down
    //             body.removeClass('scrollUp');
    //             body.addClass('scrollDown');
    //         } else if ((currentScroll < lastScroll) && body.hasClass('scrollDown')) {
    //             // up
    //             body.removeClass('scrollDown');
    //             body.addClass('scrollUp');
    //         }

    //         lastScroll = currentScroll;
    //     }
    // });


    function setSubmenuPosition() {
        const preHeaderVideoSection = $('.pre-header-video-section');
        if (preHeaderVideoSection.length && currentScreenSize > 1025) {
            const body = $('body');
            body.addClass('openSubmenuAbove');
            window.addEventListener("scroll", () => {
                let currentScroll = window.pageYOffset;
                if (currentScroll <= 0) {
                    body.addClass('openSubmenuAbove');
                } else {
                    body.removeClass('openSubmenuAbove');
                }
            }, { passive: true });
        }
    }
    setSubmenuPosition();


    // Makes entire nav button clickable
    $('.menu-item.button').on("click", function () {
        let $link_url = $(this).find('a').attr('href');
        window.location.href = $link_url;
    })


    // Handle footer spacing when form message is visible
    let targetNode = document.querySelector(".footer__form");

    let observer = new MutationObserver(function (mutations) {

        mutations.forEach(function (mutation) {
            let responseMessage = $(".footer__form .forminator-response-message");

            if (responseMessage.is(':visible')) {
                $('.footer').addClass('forminator-response-message-showing');
            }
        });
    });

    observer.observe(targetNode, { childList: true, subtree: true });

});